<template>
  <div class="media-and-text">
    <el-form ref="form" :model="form" :label-width="isEn() ? '200px' : '100px'" label-position="left">
      <el-form-item :label="$t('microSite.common.form.title')">
        <el-input v-model="form.title" :placeholder="$t('microSite.common.form.titlePlaceholder')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('microSite.common.form.subtitle')">
        <el-input v-model="form.subTitle" :placeholder="$t('microSite.common.form.subtitlePlaceholder')"></el-input>
      </el-form-item>
      <el-form-item v-if="hasHideMarginConfig" :label="$t('microSite.mediaAndText.label.hideItemMargin')">
        <SwitchButton v-model="form.hideItemMargin" :options="hideMarginOptions"></SwitchButton>
      </el-form-item>
      <el-form-item class="size-config" :label="$t('microSite.common.label.size.width')">
        <SwitchButton v-model="form.size.width.type" :options="sizeOptions.width"></SwitchButton>
        <el-slider
          v-if="form.size.width.type === SIZE_TYPE.SCREEN_PERCENTAGE"
          v-model="form.size.width.percentage"
          show-input
          :min="1"
          :max="100"
        ></el-slider>
        <el-input
          v-if="form.size.width.type === SIZE_TYPE.FIXED"
          v-model="form.size.width.fixed"
          type="number"
        >
          <template #append>px</template>
        </el-input>
      </el-form-item>
      <el-form-item v-if="hasHeightConfig" class="size-config" :label="$t('microSite.common.label.size.height')">
        <SwitchButton v-model="form.size.height.type" :options="sizeOptions.height"></SwitchButton>
        <el-slider
          v-if="form.size.height.type === SIZE_TYPE.SCREEN_PERCENTAGE"
          v-model="form.size.height.percentage"
          show-input
          :min="1"
          :max="100"
        ></el-slider>
        <el-input
          v-if="form.size.height.type === SIZE_TYPE.FIXED"
          v-model="form.size.height.fixed"
          type="number"
        >
          <template #append>px</template>
        </el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { isEn } from '@/i18n'
import SwitchButton from '../../../components/editor/switchButton.vue'
import editorTemplate from '../../editorTemplate'
import { SIZE_TYPE } from '../../renderMixin'
import { RENDER_MODE } from '../constant'

export default {
  mixins: [editorTemplate],
  components: {
    SwitchButton
  },
  data () {
    return {
      isEn,
      form: {
        title: null,
        subTitle: null,
        hideItemMargin: false,
        size: {
          width: {
            type: SIZE_TYPE.FIXED,
            fixed: null,
            percentage: null
          },
          height: {
            type: SIZE_TYPE.AUTO,
            fixed: null,
            percentage: null
          }
        }
      },
      hideMarginOptions: [
        {
          labelI18nKey: 'microSite.common.form.no',
          value: false
        },
        {
          labelI18nKey: 'microSite.common.form.yes',
          value: true
        }
      ]
    }
  },
  computed: {
    hasHeightConfig () {
      return false
    },
    hasHideMarginConfig () {
      return this.renderData.data.props.renderMode === RENDER_MODE.horizontalSingle
    }
  },
  created () {
    const props = this.renderData.data.props
    this.form.title = props.title
    this.form.subTitle = props.subTitle
    this.form.hideItemMargin = props.hideItemMargin || false
    const size = props.size
    this.form.size = {
      width: {
        type: size?.width?.type || (this.isMobile ? SIZE_TYPE.SCREEN_PERCENTAGE : SIZE_TYPE.FIXED),
        fixed: size?.width?.fixed || (this.isMobile ? 375 : 1080),
        percentage: size?.width?.percentage || 100
      },
      height: {
        type: size?.height?.type || SIZE_TYPE.AUTO,
        fixed: size?.height?.fixed,
        percentage: size?.height?.percentage || 50
      }
    }
  },
  methods: {
    validateAndUpdateRenderData () {
      let result = false
      this.$refs.form.validate(valid => { result = valid })
      if (!result) {
        return result
      }
      const props = this.renderData.data.props
      props.title = this.form.title
      props.subTitle = this.form.subTitle
      props.hideItemMargin = this.form.hideItemMargin
      const size = this.form.size
      this.$set(props, 'size', {
        width: {
          type: size.width.type,
          fixed: this.parseToInt(size.width.fixed),
          percentage: this.parseToInt(size.width.percentage)
        },
        height: {
          type: size.height.type,
          fixed: this.parseToInt(size.height.fixed),
          percentage: this.parseToInt(size.height.percentage)
        }
      })

      this.updateConfigInRoot()
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.media-and-text {
  .size-config {
    .el-slider {
      margin-top: 15px;
    }
    .el-input {
      margin-top: 15px;
      ::v-deep {
        .el-input__inner[type="number"] {
          appearance: textfield;
          &::-webkit-inner-spin-button {
            appearance: none;
          }
        }
      }
    }
  }
}
</style>
